// petImages.ts
// Mapping of pet names to their image URLs
// Pets are summoned entities that deal damage on behalf of their owner champion

export const petImages: Record<string, string> = {
  // Annie's Tibbers - uses the R2 (command) icon
  "Tibbers": "https://raw.communitydragon.org/15.3/game/assets/characters/annie/hud/icons2d/annie_r2.png",
  "Sand Soldier": "https://raw.communitydragon.org/15.3/game/assets/characters/azir/hud/icons2d/azir_w.png",
  "Powder Keg": "https://raw.communitydragon.org/15.3/game/assets/characters/gangplank/hud/icons2d/gangplank_e.png",
  "Tentacle": "https://raw.communitydragon.org/15.3/game/assets/characters/illaoi/hud/icons2d/illaoi_p.png",
  "Spirit": "https://raw.communitydragon.org/latest/game/assets/characters/illaoi/hud/icons2d/illaoi_e.png",
  "H-28G Evolution Turret": "https://raw.communitydragon.org/latest/game/assets/characters/heimerdinger/hud/icons2d/heimerdinger_q1.png",
  "Packmate": "https://raw.communitydragon.org/latest/game/assets/characters/naafiri/hud/icons2d/icons_naafiri_p.png",
  "Thorn Spitter": "https://raw.communitydragon.org/latest/game/assets/characters/zyra/hud/icons2d/zyraq.png",
  "Vine Lasher": "https://raw.communitydragon.org/latest/game/assets/characters/zyra/hud/icons2d/zyrae.png",
  "WukongClone": "https://raw.communitydragon.org/latest/game/assets/characters/monkeyking/hud/icons2d/monkeykingdecoy.png",
  "Jack in the Box": "https://raw.communitydragon.org/latest/game/assets/characters/shaco/hud/icons2d/jester_deathward.png",
  "ShacoMiniBox": "https://raw.communitydragon.org/latest/game/assets/characters/shaco/hud/icons2d/jester_deathward.png",
  "ShacoClone": "https://raw.communitydragon.org/latest/game/assets/characters/shaco/hud/icons2d/jester_hallucinogenbomb.png",
 
};

// Helper function to get pet image URL
export function getPetImageUrl(petName: string): string | undefined {
  return petImages[petName];
}

export default petImages;

